/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 * Overall, BlockTypes fall into four different categories:
 * 1. ReturnTypes: these are blocks which represent an input that is not tracked as a global. The data collected
 * inside of this block is only accessible in the scope of the task.
 * 2. Properties: these are blocks like fields and databases which are tracked as a global. Data collected
 * inside of this block is will write directly to that global.
 * 3. Modules: these are blocks where we've built a custom collection experience for borrowers. Data collected inside
 * of this block will also write directly to a global.
 * 4. Special block types: these are special block types that don't accept input.
 */
export enum BlockTypeEnum {
    NUMBER = 'NUMBER',
    CURRENCY = 'CURRENCY',
    PERCENT = 'PERCENT',
    SHORT_TEXT = 'SHORT_TEXT',
    LONG_TEXT = 'LONG_TEXT',
    YES_OR_NO = 'YES_OR_NO',
    DATE = 'DATE',
    DOCUMENT = 'DOCUMENT',
    SINGLE_SELECT = 'SINGLE_SELECT',
    MULTI_SELECT = 'MULTI_SELECT',
    DATABASE = 'DATABASE',
    FINANCIAL_ACCOUNTS = 'FINANCIAL_ACCOUNTS',
    RICH_TEXT = 'RICH_TEXT',
    SIGNATURE = 'SIGNATURE',
    CONDITIONAL_GROUP = 'CONDITIONAL_GROUP',
    SECTION = 'SECTION',
}
